export { default } from './CoreValuesSection';
